import { Provider } from '@angular/core';

import { TwoFactorRepositoryImpl } from '@app/data/repositories/ptrab/two-factor/two-factor.repository';
import { TWO_FACTOR_REPOSITORY } from '@app/domain/repositories/ptrab/two-factor/two-factor.repository.contract';

export const twoFactorRepositoryProvider: Provider = {
  provide: TWO_FACTOR_REPOSITORY,
  useClass: TwoFactorRepositoryImpl
};
